var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuieroPostularme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 11.5556H1.44444V1.44444H8.66667V0H1.44444C0.642778 0 0 0.642778 0 1.44444V11.5556C0 11.9386 0.152182 12.306 0.423068 12.5769C0.693954 12.8478 1.06135 13 1.44444 13H11.5556C11.9386 13 12.306 12.8478 12.5769 12.5769C12.8478 12.306 13 11.9386 13 11.5556V5.77778H11.5556V11.5556ZM3.54611 5.11333L2.52778 6.13889L5.77778 9.38889L13 2.16667L11.9817 1.14111L5.77778 7.345L3.54611 5.11333Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuieroPostularme);
export default __webpack_public_path__ + "static/media/quieroPostularme.06a47a0784e132b064dc949011eab7ec.svg";
export { ForwardRef as ReactComponent };